export default {
    encode: function(string) {
        return unescape(encodeURIComponent(string));
    },

    decode: function(string) {
        return decodeURIComponent(escape(string));
    }
};



// WEBPACK FOOTER //
// ./src/abusesa-js/utf8.js